import type { Language } from "@heredajo/schema";

export const ALL_LANGS: Language[] = ["en", "de", "fr", "eo"];

export const LANG_LABEL: Record<Language, string> = {
  en: "English",
  de: "Deutsch",
  fr: "Français",
  eo: "Esperanto",
};

const STORAGE_KEY = "heredajo.lang";

function isLanguage(value: string): value is Language {
  return value === "en" || value === "de" || value === "fr" || value === "eo";
}

function detectBrowserLang(): Language {
  if (typeof navigator === "undefined") return "en";
  const candidates = [...(navigator.languages ?? []), navigator.language ?? ""];
  for (const raw of candidates) {
    const short = raw.toLowerCase().split("-")[0];
    if (short && isLanguage(short)) return short;
  }
  return "en";
}

export function loadPreferredLang(): Language {
  if (typeof window === "undefined") return "en";
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored && isLanguage(stored)) return stored;
  return detectBrowserLang();
}

export function savePreferredLang(lang: Language): void {
  if (typeof window !== "undefined") {
    window.localStorage.setItem(STORAGE_KEY, lang);
  }
}

export type ReadingTab = "translation" | "transcription";
const TAB_STORAGE_KEY = "heredajo.tab";

function isReadingTab(value: string): value is ReadingTab {
  return value === "translation" || value === "transcription";
}

export function loadPreferredTab(): ReadingTab {
  if (typeof window === "undefined") return "translation";
  const stored = window.localStorage.getItem(TAB_STORAGE_KEY);
  if (stored && isReadingTab(stored)) return stored;
  return "translation";
}

export function savePreferredTab(tab: ReadingTab): void {
  if (typeof window !== "undefined") {
    window.localStorage.setItem(TAB_STORAGE_KEY, tab);
  }
}
